import { toArray as u } from "./array.js";
import { isVisibleCached as s, notHiddenInput as c, isAutoFocusAllowedCached as b } from "./is.js";
import { orderByTabIndex as a } from "./tabOrder.js";
import { getFocusables as l, getParentAutofocusables as d } from "./tabUtils.js";
var i = function(t, r) {
  return u(t).filter(function(n) {
    return s(r, n);
  }).filter(function(n) {
    return c(n);
  });
}, F = function(t, r) {
  return r === void 0 && (r = /* @__PURE__ */ new Map()), u(t).filter(function(n) {
    return b(r, n);
  });
}, p = function(t, r, n) {
  return a(i(l(t, n), r), !0, n);
}, y = function(t, r) {
  return a(i(l(t), r), !1);
}, O = function(t, r) {
  return i(d(t), r);
}, e = function(t, r) {
  return t.shadowRoot ? e(t.shadowRoot, r) : Object.getPrototypeOf(t).contains !== void 0 && Object.getPrototypeOf(t).contains.call(t, r) ? !0 : u(t.children).some(function(n) {
    var o;
    if (n instanceof HTMLIFrameElement) {
      var f = (o = n.contentDocument) === null || o === void 0 ? void 0 : o.body;
      return f ? e(f, r) : !1;
    }
    return e(n, r);
  });
};
export {
  e as contains,
  F as filterAutoFocusable,
  i as filterFocusable,
  y as getFocusableNodes,
  p as getTabbableNodes,
  O as parentAutofocusables
};
//# sourceMappingURL=DOMutils.js.map
